import React from 'react';

import { LifeSaver } from '../components/logo';

const BeneficiaryNotificationPage = () => {
  // Sample data - would come from URL params or API
  const notification = {
    grantor: {
      name: 'John Smith',
      email: 'john.smith@email.com'
    },
    recipient: {
      name: 'Mary Sue',
      email: 'mary.sue@email.com',
      phone: '(555) 123-4567'
    }
  };

  const responsibilities = [
    {
      type: 'Executor',
      description: 'You have been named as the primary executor of John\'s will and estate',
      icon: 'M12,2A2,2 0 0,1 14,4V8L15,7L16.5,7C17.74,7 18.74,7.86 18.95,9.05C19.16,10.24 18.45,11.39 17.34,11.78L17.5,12C18.88,12 20,13.12 20,14.5C20,15.88 18.88,17 17.5,17H16.5L15,16L14,17V21A2,2 0 0,1 12,23H4A2,2 0 0,1 2,21V4A2,2 0 0,1 4,2H12M4,4V21H12V19H17.5A1.5,1.5 0 0,0 19,17.5A1.5,1.5 0 0,0 17.5,16H16L14,18V16L15.5,15H17.34A1.5,1.5 0 0,0 18.84,13.5A1.5,1.5 0 0,0 17.34,12H15.5L14,11V9H17.5A1.5,1.5 0 0,0 19,7.5A1.5,1.5 0 0,0 17.5,6H15L14,7V4H4Z',
      details: [
        'Manage and distribute estate assets',
        'Handle legal proceedings',
        'Pay outstanding debts and taxes',
        'Communicate with beneficiaries'
      ]
    },
    {
      type: 'Healthcare Agent',
      description: 'You are authorized to make healthcare decisions if John becomes unable to do so',
      icon: 'M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z',
      details: [
        'Make medical treatment decisions',
        'Access medical records',
        'Choose healthcare providers',
        'Implement end-of-life wishes'
      ]
    }
  ];

  const assets = [
    {
      type: 'Bank Account',
      name: 'Chase Savings Account',
      percentage: '50%',
      estimatedValue: '$45,000',
      icon: 'M5,6H23V18H5V6M14,9A3,3 0 0,1 17,12A3,3 0 0,1 14,15A3,3 0 0,1 11,12A3,3 0 0,1 14,9M9,8A2,2 0 0,1 7,10V14A2,2 0 0,1 9,16H19A2,2 0 0,1 21,14V10A2,2 0 0,1 19,8H9Z',
      accountNumber: '****1234'
    },
    {
      type: 'Investment Account', 
      name: 'Fidelity 401(k)',
      percentage: '25%',
      estimatedValue: '$75,000',
      icon: 'M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z',
      accountNumber: '****5678'
    },
    {
      type: 'Real Estate',
      name: 'Family Home',
      percentage: '33%',
      estimatedValue: '$200,000',
      icon: 'M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z',
      address: '456 Oak Street, Burbank, CA'
    },
    {
      type: 'Personal Items',
      name: 'Vintage Watch Collection',
      percentage: '100%',
      estimatedValue: '$12,500',
      icon: 'M12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12.5,7V12.25L17,14.92L16.25,16.15L11,13V7H12.5Z',
      description: 'Collection of 8 vintage timepieces'
    }
  ];

  const styles = {
    container: {
      backgroundColor: '#f5f5f5',
      minHeight: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    },
    header: {
      background: 'linear-gradient(135deg, #4285F4 0%, #5a9cf8 100%)',
      color: 'white',
      padding: '32px 20px',
      textAlign: 'center' as const
    },
    headerTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '8px'
    },
    headerSubtitle: {
      fontSize: '16px',
      opacity: 0.9
    },
    content: {
      padding: '20px',
      maxWidth: '500px',
      margin: '0 auto'
    },
    notificationCard: {
      backgroundColor: '#e8f5e8',
      border: '1px solid #ceead6',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '24px',
      textAlign: 'center' as const
    },
    notificationIcon: {
      width: '48px',
      height: '48px',
      backgroundColor: '#137333',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 16px',
      color: 'white'
    },
    notificationTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#137333',
      marginBottom: '8px'
    },
    notificationMessage: {
      fontSize: '16px',
      color: '#333',
      lineHeight: '1.5'
    },
    contactSection: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '20px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    },
    sectionTitle: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '16px',
      display: 'flex',
      alignItems: 'center'
    },
    sectionIcon: {
      width: '20px',
      height: '20px',
      marginRight: '8px',
      color: '#4285F4'
    },
    contactInfo: {
      backgroundColor: '#f8f9fa',
      padding: '16px',
      borderRadius: '8px'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '12px',
      fontSize: '14px',
      color: '#333'
    },
    contactItemLast: {
      marginBottom: 0
    },
    contactIcon: {
      width: '16px',
      height: '16px',
      marginRight: '12px',
      color: '#666',
      flexShrink: 0
    },
    section: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '16px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    },
    responsibilityItem: {
      marginBottom: '24px',
      paddingBottom: '24px',
      borderBottom: '1px solid #f0f0f0'
    },
    responsibilityItemLast: {
      marginBottom: 0,
      paddingBottom: 0,
      borderBottom: 'none'
    },
    responsibilityHeader: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '12px'
    },
    responsibilityIcon: {
      width: '40px',
      height: '40px',
      backgroundColor: '#4285F4',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '16px',
      flexShrink: 0
    },
    responsibilityIconSvg: {
      width: '20px',
      height: '20px',
      color: 'white'
    },
    responsibilityContent: {
      flex: 1
    },
    responsibilityType: {
      fontSize: '18px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '4px'
    },
    responsibilityDescription: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '12px'
    },
    responsibilityDetails: {
      marginLeft: '56px'
    },
    detailsList: {
      listStyle: 'none',
      padding: 0,
      margin: 0
    },
    detailItem: {
      fontSize: '14px',
      color: '#333',
      marginBottom: '6px',
      paddingLeft: '16px',
      position: 'relative' as const
    },
    detailBullet: {
      position: 'absolute' as const,
      left: '0',
      top: '6px',
      width: '4px',
      height: '4px',
      backgroundColor: '#4285F4',
      borderRadius: '50%'
    },
    assetItem: {
      display: 'flex',
      alignItems: 'flex-start',
      padding: '16px',
      backgroundColor: '#fff8f0',
      border: '1px solid #ffe8d1',
      borderRadius: '8px',
      marginBottom: '12px'
    },
    assetItemLast: {
      marginBottom: 0
    },
    assetIcon: {
      width: '40px',
      height: '40px',
      backgroundColor: '#ff9500',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: '16px',
      flexShrink: 0
    },
    assetIconSvg: {
      width: '20px',
      height: '20px',
      color: 'white'
    },
    assetContent: {
      flex: 1
    },
    assetHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: '8px'
    },
    assetName: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#333'
    },
    assetPercentage: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#ff9500',
      backgroundColor: 'white',
      padding: '4px 8px',
      borderRadius: '12px',
      border: '1px solid #fdd663'
    },
    assetDetails: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '4px'
    },
    assetValue: {
      fontSize: '16px',
      fontWeight: '600',
      color: '#333'
    },
    actionButtons: {
      display: 'flex',
      gap: '12px',
      marginTop: '24px'
    },
    primaryButton: {
      flex: 1,
      backgroundColor: '#4285F4',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '16px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    },
    secondaryButton: {
      flex: 1,
      backgroundColor: 'white',
      color: '#4285F4',
      border: '2px solid #4285F4',
      borderRadius: '8px',
      padding: '14px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'all 0.2s ease'
    },
    disclaimer: {
      backgroundColor: '#fef7e0',
      border: '1px solid #fdd663',
      borderRadius: '8px',
      padding: '16px',
      marginTop: '20px'
    },
    disclaimerTitle: {
      fontSize: '14px',
      fontWeight: '600',
      color: '#b06000',
      marginBottom: '8px'
    },
    disclaimerText: {
      fontSize: '13px',
      color: '#b06000',
      lineHeight: '1.4'
    },
    bottomSpacer: {
      height: '40px'
    }
  };

  const [ hoveredButton, setHoveredButton ] = React.useState(null);

  return (
    <div style={styles.container}>
      <div className="header-component" style={{ height: '64px' }}>
        <LifeSaver />
      </div>

      <div style={styles.content}>
        {/* Notification Card */}
        <div style={styles.notificationCard}>
          <div style={styles.notificationIcon}>
            <svg viewBox="0 0 24 24" fill="currentColor" style={{ width: '24px', height: '24px' }}>
              <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/>
            </svg>
          </div>
          <div style={styles.notificationTitle}>You've Been Named in an Estate Plan</div>
          <div style={styles.notificationMessage}>
            <strong>{notification.grantor.name}</strong> has named you in their estate planning documents. 
            Please review the details below to understand your responsibilities and inheritance.
          </div>
        </div>

        {/* Your Contact Information */}
        <div style={styles.contactSection}>
          <div style={styles.sectionTitle}>
            <svg style={styles.sectionIcon} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
            </svg>
            Your Information on File
          </div>
          <div style={styles.contactInfo}>
            <div style={styles.contactItem}>
              <svg style={styles.contactIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
              </svg>
              {notification.recipient.name}
            </div>
            <div style={styles.contactItem}>
              <svg style={styles.contactIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.11,4 20,4Z"/>
              </svg>
              {notification.recipient.email}
            </div>
            <div style={{ ...styles.contactItem, ...styles.contactItemLast }}>
              <svg style={styles.contactIcon} viewBox="0 0 24 24" fill="currentColor">
                <path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
              </svg>
              {notification.recipient.phone}
            </div>
          </div>
        </div>

        {/* Responsibilities */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>
            <svg style={styles.sectionIcon} viewBox="0 0 24 24" fill="currentColor">
              <path d="M12,2A2,2 0 0,1 14,4V8L15,7L16.5,7C17.74,7 18.74,7.86 18.95,9.05C19.16,10.24 18.45,11.39 17.34,11.78L17.5,12C18.88,12 20,13.12 20,14.5C20,15.88 18.88,17 17.5,17H16.5L15,16L14,17V21A2,2 0 0,1 12,23H4A2,2 0 0,1 2,21V4A2,2 0 0,1 4,2H12M4,4V21H12V19H17.5A1.5,1.5 0 0,0 19,17.5A1.5,1.5 0 0,0 17.5,16H16L14,18V16L15.5,15H17.34A1.5,1.5 0 0,0 18.84,13.5A1.5,1.5 0 0,0 17.34,12H15.5L14,11V9H17.5A1.5,1.5 0 0,0 19,7.5A1.5,1.5 0 0,0 17.5,6H15L14,7V4H4Z"/>
            </svg>
            Your Responsibilities
          </div>

          {responsibilities.map((responsibility, index) => (
            <div 
              key={index}
              style={{
                ...styles.responsibilityItem,
                ...(index === responsibilities.length - 1 ? styles.responsibilityItemLast : {})
              }}
            >
              <div style={styles.responsibilityHeader}>
                <div style={styles.responsibilityIcon}>
                  <svg style={styles.responsibilityIconSvg} viewBox="0 0 24 24" fill="currentColor">
                    <path d={responsibility.icon}/>
                  </svg>
                </div>
                <div style={styles.responsibilityContent}>
                  <div style={styles.responsibilityType}>{responsibility.type}</div>
                  <div style={styles.responsibilityDescription}>{responsibility.description}</div>
                </div>
              </div>
              <div style={styles.responsibilityDetails}>
                <ul style={styles.detailsList}>
                  {responsibility.details.map((detail, detailIndex) => (
                    <li key={detailIndex} style={styles.detailItem}>
                      <div style={styles.detailBullet}></div>
                      {detail}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* Assets */}
        <div style={styles.section}>
          <div style={styles.sectionTitle}>
            <svg style={styles.sectionIcon} viewBox="0 0 24 24" fill="currentColor">
              <path d="M5,6H23V18H5V6M14,9A3,3 0 0,1 17,12A3,3 0 0,1 14,15A3,3 0 0,1 11,12A3,3 0 0,1 14,9M9,8A2,2 0 0,1 7,10V14A2,2 0 0,1 9,16H19A2,2 0 0,1 21,14V10A2,2 0 0,1 19,8H9Z"/>
            </svg>
            Assets You Will Inherit
          </div>

          {assets.map((asset, index) => (
            <div 
              key={index}
              style={{
                ...styles.assetItem,
                ...(index === assets.length - 1 ? styles.assetItemLast : {})
              }}
            >
              <div style={styles.assetIcon}>
                <svg style={styles.assetIconSvg} viewBox="0 0 24 24" fill="currentColor">
                  <path d={asset.icon}/>
                </svg>
              </div>
              <div style={styles.assetContent}>
                <div style={styles.assetHeader}>
                  <div style={styles.assetName}>{asset.name}</div>
                  <div style={styles.assetPercentage}>{asset.percentage}</div>
                </div>
                <div style={styles.assetDetails}>
                  {asset.type}
                  {asset.accountNumber && ` • ${asset.accountNumber}`}
                  {asset.address && ` • ${asset.address}`}
                  {asset.description && ` • ${asset.description}`}
                </div>
                <div style={styles.assetValue}>Est. Value: {asset.estimatedValue}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Action Buttons */}
        <div style={styles.actionButtons}>
          <button 
            style={{
              ...styles.primaryButton,
              ...(hoveredButton === 'accept' ? { backgroundColor: '#3367d6' } : {})
            }}
            onMouseEnter={() => setHoveredButton('accept')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            Accept Responsibilities
          </button>
          <button 
            style={{
              ...styles.secondaryButton,
              ...(hoveredButton === 'contact' ? { backgroundColor: '#f8f9ff' } : {})
            }}
            onMouseEnter={() => setHoveredButton('contact')}
            onMouseLeave={() => setHoveredButton(null)}
          >
            Contact {notification.grantor.name}
          </button>
        </div>

        {/* Disclaimer */}
        <div style={styles.disclaimer}>
          <div style={styles.disclaimerTitle}>Important Notice</div>
          <div style={styles.disclaimerText}>
            This is a preliminary notification. Asset values are estimates and may change. 
            Final inheritance amounts will be determined during probate proceedings. 
            Please consult with a legal professional if you have questions about your responsibilities.
          </div>
        </div>

        <div style={styles.bottomSpacer}></div>
      </div>
    </div>
  );
};

export default BeneficiaryNotificationPage;